/**
 * Created by mnaughton on 9/23/2015.
 */
import _ from "underscore";
import Backbone from "backbone";
/**
 * Creates a new clipboard.
 * @constructor
 */
function Clipboard() {
  this._items = {};
  _.extend(this, Backbone.Events);
}

Clipboard.prototype = {
  /**
   * Stores the given data in the app clipboard under the specified type.
   * @param {String} type Any string specifying the type of data to store.
   * @param data The data to store.
   */
  put: function (type, data) {
    this._items[type] = data;

    this.trigger("update:" + type);
    this.trigger("update");
  },

  /**
   * Gets a value indicating whether or not there is data with the specified type in the clipboard.
   * @param {String} type Any string specifying the type of data to check.
   */
  has: function (type) {
    return !_.isUndefined(this._items[type]);
  },

  /**
   * Gets the value with the specified type in the clipboard.
   * @param {String} type Any string specifying the type of data to store.
   */
  get: function (type) {
    return this._items[type];
  },

  /**
   * Removes the clipboard data with the specified type.
   * @param {String} type Any string specifying the type of data to store.
   */
  remove: function (type) {
    delete this._items[type];

    this.trigger("update:" + type);
    this.trigger("update");
  },

  /**
   * Removes all values from the clipboard and fires an "update" event.
   */
  clear: function () {
    this._items = {};
    this.trigger("update");
  },
};

export default new Clipboard();



//////////////////
// WEBPACK FOOTER
// ./public/js/core/Clipboard.js
// module id = 170
// module chunks = 1